import { makeStyles, typographyStyles } from "@fluentui/react-components";

export const useClauseFootnoteStyles = makeStyles({
  footNote: {
    ...typographyStyles.caption1,
  },

  ellipsisText: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "88%",
  },
  ellipsisTextWithOthers: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "63%",
  },
});
